import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEllipse = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z",
		stroke: "var(--border-disabled)"
	})
});
export default SvgEllipse;
